"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const CheckOutline = createSVGIconV2(
  <>
    <circle cx="12" cy="12" r="10.5" stroke="currentColor" />
    <path
      d="M7 12.3077L10.5714 16L17 7"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CheckOutline",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
